import { defineMessage } from 'services/localization';

export const messages = {
    errorFieldIsRequired: defineMessage('field_is_required'),
    confirmButton: defineMessage('confirm'),
    anotherMethodButton: defineMessage('use_another_authentication_method'),
    trustThisDevice: defineMessage('trust_this_device'),
    trustThisDeviceTooltip: defineMessage('your_trusted_device_wil_able_fa_on_your_account'),
};
